import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {MFASetUp} from "../mfa";
import MfaService from "../mfa.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {
  SnackBarTranslateComponent
} from "../../../../shared/snack-bar-translate/snack-bar-translate/snack-bar-translate.component";


@Component({
    selector: 'app-mfa-setup',
    templateUrl: './mfa-setup.component.html',
    styleUrls: ['./mfa-setup.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MfaSetupComponent implements OnInit {
  private mfaService = inject(MfaService);
  data = inject(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<MfaSetupComponent>>(MatDialogRef);
  private snackBar = inject(MatSnackBar);


  stage = 1;
  mfaSetup: MFASetUp;
  disabled = true;
  textValue;
  errored = false;

  ngOnInit(): void {
    this.mfaService.enableDisableMFA(true).subscribe(() => {
      this.mfaService.generateCodeMFA().subscribe(mfa => {
        this.mfaSetup = mfa;
      })
    })


  }

  next() {
    this.stage = 2;
  }

  back() {
    this.stage = 1;
    this.errored = false;
  }

  done() {
    this.completeSetup()
  }

  inputEmit(value: string) {
    this.textValue = value;
    this.disabled = this.textValue.length !== 6;

    if(value.length === 6) {
      this.completeSetup();
    }
  }

  completeSetup() {
    this.disabled = true;
    this.mfaService.verifySetUpMFA(this.textValue).subscribe(res => {
      if(res) {
        this.dialogRef.close(res);
      } else {
        this.snackBar.openFromComponent(SnackBarTranslateComponent, {
          data: {key: 'main.mfa.set-up.fail'}, duration: 10000
        });
        this.errored = true;
      }

      this.disabled = this.textValue.length !== 6;
    })
  }
}
